<template>
    <div>
        <div
            v-if="!cmsView || isSalesperson"
            class="mb-1 text-black bg-gray-100"
        >
            <div class="container relative mx-auto">
                <Tabs
                    :status="status"
                    class="hidden md:block"
                >
                    <Tab
                        title="Home"
                        :click="gotoProductsIndex"
                    />

                    <Tab
                        v-for="parentCategory in categoriesGroupedByParent"
                        :key="'parentCategory-' + parentCategory.id"
                        :title="parentCategory.name"
                        :click="filterByCategory"
                        :clickparam="parentCategory.id"
                    >
                        <div class="grid grid-cols-5 py-1 rounded-md shadow-xs h-80">
                            <div
                                v-for="(childCategoryChunk, index) in chunk(
                                    parentCategory.children,
                                    Math.floor(parentCategory.children.length / 2) + 1,
                                )"
                                :key="index + '-children-chunk'"
                                class="overflow-scroll"
                            >
                                <div
                                    v-for="childCategory in childCategoryChunk"
                                    :key="'childCategory-' + childCategory.id"
                                    class="block px-4 py-2 text-sm leading-5 text-gray-700 transition duration-150 ease-in-out cursor-pointer hover:bg-green-100 focus:outline-none focus:bg-green-100"
                                    @click="filterByCategory(childCategory.id)"
                                >
                                    {{ childCategory.name }}
                                </div>
                            </div>

                            <div
                                v-if="
                                    chunk(parentCategory.children, Math.floor(parentCategory.children.length / 2) + 1)
                                        .length === 1
                                "
                            />

                            <div class="col-span-3 bg-red-200 h-72">
                                <img
                                    :src="parentCategory.banner_path"
                                    alt="Image"
                                    class="w-full h-full"
                                >
                            </div>
                        </div>
                    </Tab>

                    <!-- commented in blocks but will need to uncomment all comments withis the below tab component
                        to enable wholesaler filterexcept the ones with comment title "already uncommented" -->
                    <!-- <Tab
                        v-if="wholesalers.length"
                        title="Wholesalers"
                    >
                        <div class="grid grid-cols-5 gap-4">
                            <div class="col-span-2"> -->
                    <!-- Search input  -->
                    <!-- <input
                                    v-model="wholesalerSearchKeyword"
                                    class="w-full h-10 px-3 py-1 border border-gray-300 rounded-lg bg-gray-50 focus:bg-gray-100 focus:outline-none focus:shadow-outline "
                                    placeholder="Search Wholesalers"
                                    @keydown.enter="getSearchResultsFor"
                                >

                                <div class="grid w-full h-64 grid-cols-2 py-1 rounded-md shadow-xs">
                                    <div
                                        v-for="(wholesalerChunk, index) in chunk(
                                            filteredWholesalers,
                                            Math.floor(filteredWholesalers.length / 2) + 1,
                                        )"
                                        :key="index + '-wholesaler-chunk'"
                                        class="overflow-scroll"
                                    >
                                        <div>
                                            <div
                                                v-for="wholesaler in wholesalerChunk"
                                                :key="'wholesaler-' + wholesaler.id"
                                                class="block px-4 py-2 text-sm leading-5 text-gray-700 transition duration-150 ease-in-out cursor-pointer hover:bg-green-100 focus:outline-none focus:bg-green-100"
                                                @click="filterByWholesaler(wholesaler.id)"
                                            >
                                                {{ wholesaler.name }}
                                            </div>
                                        </div>
                                    </div>
                                    <div
                                        v-if="
                                            chunk(filteredWholesalers, Math.floor(filteredWholesalers.length / 2) + 1)
                                                .length === 1
                                        "
                                    />
                                </div>
                            </div>
                            <div class="col-span-3 bg-red-200 h-72">
                                <img
                                    :src="`/storage/default/default_product_page.png`"
                                    alt="Image"
                                    class="w-full h-full"
                                >
                            </div>
                        </div> -->

                    <!-- already uncommented -->
                    <!-- <div class="w-96">
                            <input
                                v-model="wholesalerSearchKeyword"
                                class="w-full h-10 px-3 py-1 border border-gray-300 rounded-lg bg-gray-50 focus:bg-gray-100 focus:outline-none focus:shadow-outline "
                                placeholder="Search Wholesalers"
                                @keydown.enter="getSearchResultsFor"
                            >
                        </div> -->

                    <!-- already uncommented -->
                    <!-- <div class="grid grid-cols-5 py-1 rounded-md shadow-xs h-80">
                            <div
                                v-for="(wholesalerChunk, index) in chunk(filteredWholesalers, Math.floor(filteredWholesalers.length / 2) + 1)"
                                :key="index + '-wholesaler-chunk'"
                                class="overflow-scroll"
                            >
                                <div>
                                    <div
                                        v-for="wholesaler in wholesalerChunk"
                                        :key="'wholesaler-' + wholesaler.id"
                                        class="block px-4 py-2 text-sm leading-5 text-gray-700 transition duration-150 ease-in-out cursor-pointer hover:bg-green-100 focus:outline-none focus:bg-green-100"
                                        @click="filterByWholesaler(wholesaler.id)"
                                    >
                                        {{ wholesaler.name }}
                                    </div>
                                </div>
                            </div>
                            <div v-if="chunk(filteredWholesalers, Math.floor(filteredWholesalers.length / 2) + 1).length === 1" />
                            <div class="col-span-3 bg-red-200 h-72">
                                <img
                                    :src="`/storage/default/default_product_page.png`"
                                    alt="Image"
                                    class="w-full h-full"
                                >
                            </div>
                        </div> -->

                    <!-- </Tab> -->
                </Tabs>

                <div class="block p-4 md:hidden">
                    <TheCategoryHamburger />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import _ from 'lodash';
import Tabs from './Tabs/Tabs.vue';
import Tab from './Tabs/Tab.vue';
import TheCategoryHamburger from './TheCategoryHamburger.vue';

export default {
    components: {
        Tabs,
        Tab,
        TheCategoryHamburger,
    },

    props: {
        status: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            categoriesGroupedByParent: [],
            wholesalers: [],
            wholesalerSearchKeyword: null,

            showCategories: false,
        };
    },

    computed: {
        filteredWholesalers() {
            return this.wholesalers.filter(
                (wholesaler) => !this.wholesalerSearchKeyword
                    || wholesaler.name.toLowerCase().includes(this.wholesalerSearchKeyword.toLowerCase())
            );
        },
    },

    async beforeMount() {
        await this.fetchCategoriesGroupedByParent();
        // await this.fetchWholesalers();
    },

    methods: {
        async fetchCategoriesGroupedByParent() {
            await this.$axios.get(route('categories.groupByParent')).then((res) => {
                this.categoriesGroupedByParent = res.data.categoriesGroupedByParent;
            });
        },

        async fetchWholesalers() {
            await this.$axios.get(route('wholesalers.index')).then((res) => {
                this.wholesalers = res.data.wholesalers;
            });
        },

        filterByCategory(categoryId) {
            this.$emit('filterByCategory', categoryId);
        },

        filterByWholesaler(wholesalerId) {
            this.$emit('filterByWholesaler', wholesalerId);
        },

        chunk(array, size) {
            return _.chunk(array, size);
        },

        gotoProductsIndex() {
            this.$inertia.get(route('products.index'));
        },
    },
};
</script>
